import { render, staticRenderFns } from "./JurisdictionDetail.vue?vue&type=template&id=6dd77e36&"
import script from "./JurisdictionDetail.vue?vue&type=script&lang=js&"
export * from "./JurisdictionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports